import React, { Component } from 'react';
import { FaUserAlt } from 'react-icons/fa';
import { BiLoaderAlt } from 'react-icons/bi';
import { Redirect, withRouter } from 'react-router-dom';

import Header from '../../components/Header';
import Footer from '../../components/Footer';
import TopPage from '../../components/TopPage';
import Textarea from '../../components/Textarea';
import Button from '../../components/Button';
import ModuloTeste from '../../components/ModuloTeste';

import './style.css';
import { fetchApi } from '../../services/api';
import Loading from '../../components/Loading';
import Alert from '../../components/Alert';
import CopyInput from '../../components/CopyInput';
import { getStorage } from '../../utils/storage';
import { getLink } from '../../services/host';

class TestePaciente extends Component {
  timer = null;

  constructor(props) {
    super(props);

    this.state = {
      id: props.match.params.id !== undefined ? props.match.params.id : null,
      module_complete: 0,
      isLoading: false,
      id_paciente: null,
      nome_paciente: null,
      escolaridade: null,
      nascimento: null,
      idade: '',
      idade_teste: '',
      data_teste: '-',
      proximo_modulo: null,
      observacao: null,
      show_diagnostico: false,
      modal_diagnostico: null,
      module_processing: [false, false, false],
      module_needs_validation: [false, false, false],
      remote_link: null,
      remote_pass: null,
      is_remote: false,
      is_processing: false,
      successMessages: [],
      errorMessages: [],
    };

    this.proximoModulo = this.proximoModulo.bind(this);
    this.salvaObservacao = this.salvaObservacao.bind(this);
    this.showDiagnostico = this.showDiagnostico.bind(this);
    this.checkProcessing = this.checkProcessing.bind(this);
  }

  componentDidMount() {
    document.title = `Módulos`;
    window.scrollTo(0, 0);

    this.carregaDados();

    //timer para verifica se tem algum modulo processando
    this.checkProcessing();
    this.timer = setInterval(() => {
      this.checkProcessing();
    }, 10000);
  }

  componentWillUnmount() {
    clearInterval(this.timer);
  }

  carregaDados() {
    this.setState({ isLoading: true });

    fetchApi
      .get(process.env.REACT_APP_TESTE_LISTA_MODULOS, this.state.id)
      .then((response) => {
        if (response.data.status === 'success') {
          this.setState({
            module_complete: response.data.modulos,
            id_paciente: response.data.paciente.id_paciente,
            nascimento: response.data.paciente.nascimento,
            idade: response.data.idade,
            idade_teste: response.data.idade_teste,
            escolaridade: response.data.paciente.escolaridade,
            nome_paciente: response.data.paciente.nome,
            data_teste: response.data.teste.created_at,
            observacao: response.data.teste.observacao,
            is_remote: response.data.teste.is_remote,
            remote_link: response.data.teste.remote_link,
            remote_pass: response.data.teste.remote_pass,
          });
        }
      })
      .catch((err) => {})
      .finally(() => {
        this.setState({ isLoading: false });
      });
  }

  proximoModulo(e) {
    e.preventDefault();

    if (this.state.module_complete < 3) {
      this.setState({
        proximo_modulo: this.state.module_complete + 1,
      });
    }
  }

  salvaObservacao(e) {
    e.preventDefault();

    this.setState({
      isLoading: true,
      successMessages: [],
      errorMessages: [],
    });

    fetchApi
      .post(
        process.env.REACT_APP_TESTE_SALVA_OBSERVACAO,
        { observacao: this.state.observacao, token: getStorage('token') },
        this.state.id,
      )
      .then((response) => {
        if (response.data.status === 'success') {
          this.setState({
            successMessages: response.data.messages,
          });
        } else {
          this.setState({
            errorMessages: response.data.messages,
          });
        }
      })
      .catch((err) => {
        this.setState({
          errorMessages: [
            'Ocorreu um erro inexperado. Por favor, tente novamente.',
          ],
        });
      })
      .finally(() => {
        this.setState({ isLoading: false });
      });
  }

  showDiagnostico(e) {
    e.preventDefault();

    if (!this.state.is_processing) {
      //redireciona para pagina de diagnostico
      this.setState({
        show_diagnostico: true,
      });
    } else {
      window.scrollTo(0, 0);

      this.setState({
        errorMessages: [
          'O servidor está processando os dados do teste. Por favor, aguarde e tente novamente.',
        ],
      });
    }
  }

  checkProcessing() {
    //valida se existe alguma resposta nao processada
    fetchApi
      .get(process.env.REACT_APP_TESTE_VALIDA_PROCESSAMENTO, this.state.id)
      .then((response) => {
        if (response.data.status === 'success') {
          //seta dados e para de atualizar
          this.setState({
            module_processing: response.data.processing,
            module_needs_validation: response.data.needValidation,
            is_processing: false,
          });

          clearInterval(this.timer);
        } else {
          this.setState({
            module_processing: response.data.processing,
            module_needs_validation: response.data.needValidation,
            is_processing: response.data.processing.includes(true)
              ? true
              : false,
          });
        }
      });
  }

  needValidation = () => this.state.module_needs_validation.includes(true);

  render() {
    var content = [];
    for (var i = 1; i < 4; i++) {
      if (this.state.module_complete >= i) {
        content.push(
          <ModuloTeste
            key={i}
            id_teste={this.state.id}
            modulo={`Módulo ${i}`}
            status={1}
            n_modulo={i}
            isLoading={this.state.module_processing[i - 1]}
            need_validation={this.state.module_needs_validation[i - 1]}
          />,
        );
      } else {
        content.push(
          <ModuloTeste
            key={i}
            id_teste={this.state.id}
            modulo={`Módulo ${i}`}
            status={0}
            n_modulo={i}
            isLoading={this.state.module_processing[i - 1]}
            need_validation={this.state.module_needs_validation[i - 1]}
          />,
        );
      }
    }

    return (
      <div>
        <Header />
        <div className="content">
          <TopPage
            title={this.state.nome_paciente}
            back={getLink(`/perfil-paciente/${this.state.id_paciente}`)}
            small={`Data de nascimento: ${this.state.nascimento} - ${this.state.idade}`}
            small2={`Idade ao realizar o teste: ${this.state.idade_teste}`}
            small3={`Escolaridade: ${this.state.escolaridade}`}
            small4={`Data do teste: ${this.state.data_teste}`}
            icon={true}
          >
            <FaUserAlt />
          </TopPage>

          <div id="salvar-observacao">
            {this.state.successMessages.length > 0 ? (
              <Alert tipo="success" messages={this.state.successMessages} />
            ) : null}
            {this.state.errorMessages.length > 0 ? (
              <Alert tipo="error" messages={this.state.errorMessages} />
            ) : null}

            {this.state.is_remote ? (
              <div className="show-dados-teste-all">
                <div className="show-dados-teste">
                  <div className="header-dados-teste">
                    Tipo de teste: Remoto
                  </div>
                </div>

                {this.state.remote_link !== '' && (
                  <div className="show-dados-teste">
                    <div className="header-dados-teste">Link do teste:</div>
                    <CopyInput value={this.state.remote_link} />
                  </div>
                )}

                {this.state.remote_pass !== '' && (
                  <div className="show-dados-teste">
                    <div className="header-dados-teste">Senha do teste:</div>
                    <CopyInput value={this.state.remote_pass} />
                  </div>
                )}
              </div>
            ) : null}

            {content.map((value) => {
              return value;
            })}

            {this.needValidation() && (
              <Alert
                tipo="warning center"
                messages={[
                  'Existem respostas a serem validadas. Valide-as para visualizar o resultado correto do teste.',
                ]}
              />
            )}

            {this.state.module_complete >= 3 ? (
              <div>
                <Textarea
                  value={this.state.observacao}
                  label="Observação sobre o teste:"
                  name="observacao"
                  id="observacao"
                  placeholder="Escreva uma observação sobre o teste"
                  rows="6"
                  onChange={(e) => {
                    this.setState({ observacao: e.target.value });
                  }}
                ></Textarea>
                <div className="align-buttons">
                  {/* <Button type="button" id="proximo-modulo" name="proximo-modulo">Próximo módulo</Button> */}
                  {!this.needValidation() ? (
                    <Button
                      type="button"
                      id="ver-resultado"
                      icon={
                        this.state.is_processing ? (
                          <div
                            className="loading-module"
                            style={{
                              position: 'relative',
                              width: 'auto',
                              height: 'auto',
                            }}
                          >
                            <BiLoaderAlt />
                          </div>
                        ) : null
                      }
                      name="ver-resultado"
                      onClick={this.showDiagnostico}
                    >
                      Ver Resultado
                    </Button>
                  ) : null}
                  <Button
                    type="button"
                    id="salvar"
                    name="salvar"
                    onClick={this.salvaObservacao}
                  >
                    Salvar
                  </Button>
                </div>
              </div>
            ) : (
              !this.state.is_remote && (
                <div className="align-buttons">
                  <Button
                    type="button"
                    id="proximo-modulo"
                    name="proximo-modulo"
                    onClick={this.proximoModulo}
                  >
                    Próximo módulo
                  </Button>
                </div>
              )
            )}
          </div>
        </div>

        {this.modal_diagnostico}

        {this.state.isLoading ? <Loading /> : null}

        {this.state.show_diagnostico !== false ? (
          <Redirect to={getLink(`/teste/${this.state.id}/diagnostico`)} />
        ) : null}
        {this.state.proximo_modulo !== null ? (
          <Redirect
            to={getLink(
              `/novo-teste/${this.state.id}/modulo/${this.state.proximo_modulo}`,
            )}
          />
        ) : null}

        <Footer />
      </div>
    );
  }
}

export default withRouter(TestePaciente);
